import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import { useAuthContext } from '@/context/AuthContext';

const GET_STATEMENT_YEARS = gql`
  query GetStatementYears {
    statementYears
  }
`;

const useStatementYears = (skip = false) => {

  const { data, loading, error } = useQuery(GET_STATEMENT_YEARS, {
      skip: skip
  });

  return {
    allYears: data?.statementYears || null,
    loading,
    errorYear: error?.message || null,
  };
};

export default useStatementYears;
